module.exports = __webpack_public_path__ + "img/arrow-pin-large.09a6e51f.png";